import ohmyfood from '../assets/images/projets-img/ohmyfood.png';
import booki from '../assets/images/projets-img/booki.png';
import sophiebluel from '../assets/images/projets-img/sophiebluel.png';
import kasa from '../assets/images/projets-img/kasa.png';
import nina from '../assets/images/projets-img/nina.png';
import events from '../assets/images/projets-img/events.png';
import argentbank from '../assets/images/projets-img/argentbank.png';
import qwenta from '../assets/images/projets-img/qwenta.png';
import cities from '../assets/images/projets-img/rigindcities.png';
import Reactjs from '../assets/images/skills/react.svg';
import css from '../assets/images/skills/css.svg';
import redux from '../assets/images/skills/redux.svg';
import sass from '../assets/images/skills/sass.svg';
import lighthouse from '../assets/images/skills/lighthouse.svg';



const data = [
  {
    "id": "2",
    "image": ohmyfood,
    "title": "Oh my food",
    "alt": "oh my food",
    "skills": css,
    "description": "Améliorer l'interface d'un site mobile avec des animations css",
    "competences": "intégrer une maquette en mobile-first, mettre en oeuvre des animations CSS, utiliser SASS",
    "github" : "https://github.com/bakta-co/projet_4-ohmyfood",
    "site" : "https://bakta-co.github.io/projet_4-ohmyfood/"
  },  
  {
    "id": "5",
    "title": "Qwenta",
    "image": qwenta,
    "alt": "oh my food",
    "skills": "Agile, veille informationnelle",
    "description": "Planifier le développement du site d'un client",
    "competences": "mettre en place un outil de veille, trouver les solutions techniques repondant aux besoins",
    "github": "",
    "site":"",
  },
  {
    "id": "6",
    "title": "Kasa",
    "image": kasa,
    "alt": "kasa",
    "skills": Reactjs,
    "description": "Créer une application WEB de location immobilière",
    "competences": "démarer un projet react avec Create React App, Utiliser React Router pour configurer la navigation entre les pages",
    "github": "https://github.com/bakta-co/projet8-Kasa",
    "site": ""
  },
  {
    "id": "7",
    "title": "Nina Carducci",
    "image": nina,
    "alt": "oh my food",
    "skills": lighthouse,
    "description": "Optimiser le référencement d'un site de photographe",
    "competences": "Optimisation du référencement et de l'accéssibilité d'un site web et améliorer ses performances",
    "github": "https://github.com/bakta-co/ninacarducci",
    "site": "https://bakta-co.github.io/ninacarducci/"
  },
  {
    "id": "8",
    "title": "724events",
    "image": events,
    "alt": "724events",
    "skills": "debug",
    "description": "Debugguer le site d'une agence d'événementiel",
    "competences": "Identifier et comprendre les bugs existants, utiliser des outils comme React Developer Tools, écrire un cahier de recette",
    "github": "https://github.com/bakta-co/724events",
    "site": ""
  },
  {
    "id": "9",
    "title": "ArgentBank",
    "image": argentbank,
    "alt": "oh my food",
    "skills": redux,
    "description": "Implémenter le front-end d'une application bancaire avec React",
    "competences": "Intégrer le front-end avec le back-end via des appels API, utiliser Redux pour gérer les données de l'application, définir les points d'accès de l'API et modéliser les interactions avec les données avec Swagger",
    "github": "https://github.com/bakta-co/ArgentBank",
    "site": ""
  },
    
  ]

  export default data;



  

 
  

  



